<template>
	<div class="s-w-full s-border-t s-border-gray-300 s-rounded s-bg-white">
		<JFlex class="s-items-center s-p-4">
			<JInputText :value="searchTerm" @input="handleInput($event)" :placeholder="$t('core.searchFiles')" />
			<button class="s-p-1 s-appearance-none focus:s-outline-none" @click="clearSearch">
				<svg
					width="24"
					height="24"
					fill="none"
					stroke-linecap="round"
					stroke-linejoin="round"
					stroke-width="2"
					viewBox="0 0 24 24"
					stroke="currentColor"
				>
					<path d="M6 18L18 6M6 6l12 12"></path>
				</svg>
			</button>
		</JFlex>

		<JBox v-if="files.length > 0" class="s-border-t s-border-gray-300 s-p-4">
			<div
				v-for="(item, i) in files"
				:key="i"
				class="s-py-2 s-my-2 hover:s-bg-indigo-100 s-cursor-pointer"
				:class="{
					's-bg-indigo-100': selectedFileIndex === i
				}"
				@click="onSelectFile(item, i)"
			>
				<div class="s-text-gray-900 s-font-medium s-px-2">
					{{ item.fileName }}
				</div>
				<div class="s-text-gray-500 s-px-2">
					{{ item.key }}
				</div>
			</div>
		</JBox>
	</div>
</template>

<script>
import api from "@/api/api"
import { query } from "../../api/queries"
import debounce from "lodash.debounce"

export default {
	props: {
		bucketName: {
			type: String,
			required: true
		}
	},

	data() {
		return {
			searchTerm: null,
			files: [],
			selectedFileIndex: null
		}
	},
	methods: {
		handleInput(value) {
			this.searchTerm = value
			this.debouncedSearchFile()
		},
		debouncedSearchFile: debounce(function() {
			this.searchFiles(this.searchTerm)
		}, 500),

		async searchFiles(keyPattern) {
			const variables = {
				bucketName: this.bucketName,
				where: {
					keyPattern
				}
			}
			const res = await api({ query: query.searchFiles, variables })
			this.files = res?.data?.searchFiles
		},

		onSelectFile(item, index) {
			this.selectedFileIndex = index
			this.$emit("file:selected", item)
		},
		clearSearch() {
			this.searchTerm = null
			this.selectedFileIndex = null
			this.files = []
		}
	}
}
</script>
